import React, { useState } from "react";
import "../styles/Home.css";
import "../components/Contact.css";
import meImage from "../assets/homepic.png";
import portfolioImage from "../assets/port.png";


function Home() {
    const [showPopup, setShowPopup] = useState(false);
    return (
        <div
            className="home"
        >
            <section className="portfolio-intro">
                <div className="portfolio-photo-wrap">
                    <img src={portfolioImage} alt="Arabella portfolio" className="portfolio-photo" />
                </div>
            </section>

            {/* ── HERO ── */}
            <section className="hero-section">
                <div className="hero">

                    {/* Left: Text */}
                    <div className="hero-text">
                        <p className="greeting">Hello, I'm</p>

                        <h1 className="hero-name">
                            Arabella Nipay<br />
                            <span className="highlight">Resaba</span>
                        </h1>

                        <p className="hero-title">
                            Computer Engineering Student &nbsp;|&nbsp;
                            <strong>Aspiring Software Developer</strong> &nbsp;|&nbsp;
                            Tech Enthusiast
                        </p>

                        <p className="hero-bio">
                            A passionate Computer Engineering student dedicated to crafting
                            elegant solutions through code. I thrive at the intersection of
                            hardware and software, always eager to learn and build things
                            that make a difference.
                        </p>

                        {/* Social Icons */}
                        {/* eslint-disable jsx-a11y/anchor-is-valid */}
                        <div className="socials">
                            <a href="https://github.com/s2023101870-create" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="GitHub">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 .5C5.648.5.5 5.648.5 12c0 5.087 3.292 9.4 7.862 10.924.575.105.786-.249.786-.553 0-.273-.01-1.179-.016-2.142-3.2.695-3.877-1.54-3.877-1.54-.523-1.329-1.278-1.683-1.278-1.683-1.044-.714.08-.7.08-.7 1.155.082 1.763 1.186 1.763 1.186 1.026 1.757 2.692 1.25 3.35.956.104-.744.4-1.25.728-1.537-2.554-.29-5.24-1.277-5.24-5.685 0-1.257.45-2.284 1.185-3.088-.119-.29-.514-1.46.112-3.044 0 0 .967-.31 3.167 1.18A11.02 11.02 0 0 1 12 6.844c.979.005 1.964.133 2.884.39 2.198-1.49 3.163-1.18 3.163-1.18.628 1.584.233 2.754.114 3.044.739.804 1.184 1.831 1.184 3.088 0 4.42-2.69 5.392-5.254 5.675.414.356.783 1.058.783 2.132 0 1.54-.014 2.781-.014 3.16 0 .307.207.664.793.55C20.712 21.396 24 17.084 24 12 24 5.648 18.352.5 12 .5z" />
                                </svg>
                            </a>
                            <a href="https://www.linkedin.com/in/arabella-resaba-b24064368?utm_source=share_via&utm_content=profile&utm_medium=member_ios" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                                </svg>
                            </a>
                            <a href="https://www.facebook.com/arabella.resaba" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.413c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
                                </svg>
                            </a>
                            <a href="mailto:s2023101870@firstasia.edu.ph" className="social-icon" aria-label="Email">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
                                </svg>
                            </a>
                        </div>
                        {/* eslint-enable jsx-a11y/anchor-is-valid */}

                        <div className="hero-btns">
                            <div style={{ position: "relative" }}>
                                <button className="btn-primary" onClick={() => setShowPopup(!showPopup)}>Hire Me</button>
                                {showPopup && (
                                    <>
                                        <div className="contact-popup-backdrop" onClick={() => setShowPopup(false)} />
                                        <div className="contact-popup">
                                            <button className="contact-popup-close" onClick={() => setShowPopup(false)}>✕</button>
                                            <ul className="contact-popup-list">
                                                <li><span className="contact-popup-icon">📞</span><span>+63 945 852 7119</span></li>
                                                <li><span className="contact-popup-icon">✉️</span><span>s2023101870@firstasia.edu.ph</span></li>
                                                <li><span className="contact-popup-icon">📍</span><span>538, Sitio Sampalocan Malbanan, Balete, Batangas</span></li>
                                                <li><span className="contact-popup-icon">🏫</span><span>First Asia Institute of Technology and Humanities</span></li>
                                            </ul>
                                        </div>
                                    </>
                                )}
                            </div>
                            <button className="btn-outline" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>Contact Me</button>
                        </div>
                    </div>

                    {/* Right: Photo with neon glow effect */}
                    <div className="hero-photo">
                        <div className="photo-ambient" />

                        {/* Neon teardrop SVG ring */}
                        <svg className="neon-ring" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <filter id="neonGlow" x="-30%" y="-30%" width="160%" height="160%">
                                    <feGaussianBlur stdDeviation="4" result="blur1" />
                                    <feGaussianBlur stdDeviation="8" result="blur2" />
                                    <feMerge>
                                        <feMergeNode in="blur2" />
                                        <feMergeNode in="blur1" />
                                        <feMergeNode in="SourceGraphic" />
                                    </feMerge>
                                </filter>
                            </defs>
                        </svg>

                        <div className="photo-circle">
                            <img src={meImage} alt="Arabella Resaba" />
                        </div>
                    </div>

                </div>
            </section>

            {/* ── STATS BAR ── */}
            <div className="stats-bar">
                <div className="stat-item">
                    <span className="stat-number">3<sup>+</sup></span>
                    <span className="stat-label">Years of Study</span>
                </div>
                <div className="stat-item">
                    <span className="stat-number">15<sup>+</sup></span>
                    <span className="stat-label">Projects Completed</span>
                </div>
                <div className="stat-item">
                    <span className="stat-number">8<sup>+</sup></span>
                    <span className="stat-label">Technologies Learned</span>
                </div>
                <div className="stat-item">
                    <span className="stat-number">5<sup>+</sup></span>
                    <span className="stat-label">Certifications Earned</span>
                </div>
            </div>

        </div>
    );
}

export default Home;